import React, { Component } from 'react'

import './style.scss'

export default class StackPreloader extends Component {
    render() {
        return (
            <div className={'stack-preloader-wrap'}>
                <div className={'stack-preloader'} />
            </div>
        )
    }
}
